const Plyr = require('plyr');
const page = require('page');
let $overlay;

let overlayOpened = false;
$(function () {
    page({ click: false });
    $(document).on('click', '.project .thumb', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');
        page(url);
    });
    $overlay = $('#overlay');
    $(document).keydown(function (e) {
        if (e.keyCode == 27 && overlayOpened) {
            history.go(-1);
        }
    });
    $(document).on("click", '.close', function (e) {
        e.preventDefault();
        history.go(-1);
    });
    page('/portfolio/commercials/*', load, show);
    page.exit('/portfolio/commercials/*', hide);
    page('/portfolio/photography/*', load, show);
    page.exit('/portfolio/photography/*', hide);
    page('/portfolio/film-tv/*', load, show);
    page.exit('/portfolio/film-tv/*', hide);
    $overlay.scroll(function () {
        fixEdOverlay();
    });
});

function load(page, next) {
    $.get(page.path, function (html) {
        $overlay.html(html);
        const players = new Plyr('.player');
        next();
    });
}

function show() {
    overlayOpened = true;
    $overlay.addClass('active');
    setTimeout(function(){
        $('body').addClass('noscroll');
    },600);
}

function hide() {
    overlayOpened = false;
    $overlay.removeClass('active');
    $('body').removeClass('noscroll');
    $overlay.animate({scrollTop: "0px"});
    $overlay.removeClass('fixed');
    setTimeout(function(){
        $overlay.html('');
    },600);

}

function fixEdOverlay(){
    let window_width = $(window).width();
    let scrollTop = $overlay.scrollTop();
    let pixels = 150;
    if(window_width < 768) {
        pixels = 20;
    }
    if (scrollTop > pixels) {
        $overlay.addClass('fixed');
    }
    else {
        $overlay.removeClass('fixed');
    }
}